import React from 'react';
import Image from '@bitComponents/unifiedComponents/Image';
import './Football.scss';

const Football = () => {

  return (
    <div className="footballSVG">
      <Image
        src="https://ssr.col.movistar.es/api/v1/get-glyph/copa-mundo-2026-m/15/black"
        alt="Animación futbol mundial"
        className="footballSVGImage"
      />
    </div>
  );
};

export default Football;
